export const SET_PAGE_STATUS = 'SET_PAGE_STATUS'
export const PAGE_EXPIRED = 'PAGE_EXPIRED'
export const PAGE_UNBUILDABLE = 'PAGE_UNBUILDABLE'
export const PAGE_ACTIVE = 'PAGE_ACTIVE'

export const CMS_LOADED = 'loaded'
export const CMS_MISSING = 'notyetloaded'
